import { createSelector } from 'reselect';

import { RootState } from 'src/config/rootStore';

export const getGoalInterests = (state: RootState) => state.goalInterests;

export const getGoalCategories = (state: RootState) => state.goalCategories;

// those goal categories are missing `parent` property or it's null
export const getMainGoalCategoriesWithSubcategories = createSelector(
    getGoalCategories,
    goalCategories =>
        goalCategories.filter(category => !category.parent).sort((a, b) => a.order - b.order),
);
